<template>
  <v-dialog
      v-model="dialog"
      max-width="500"
  >
    <v-card>
      <v-card-title class="headline">Registrar {{ itemType.slice(0, -1) }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <v-form ref="formCreateItem" @submit.prevent="createItem">
          <v-text-field
              v-model="item.name"
              label="Nombre"
              outlined
              dense
              required
              :rules="[rules.required, rules.counter]"
          ></v-text-field>
          <v-textarea
              v-model="item.description"
              label="Descripción"
              outlined
              dense
              rows="6"
              no-resize
              maxlength="255"
              counter
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <CancelButton
            :isDisabled="isLoading"
            @click="handleDialogClose"
        />
        <CreateButton
            :isLoading="isLoading"
            :isDisabled="isInvalidForm()"
            @click="createItem"
            :label="`Registrar ${itemType.slice(0, -1)}`"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";

import throwSuccessMessage from "@/utils/SuccessMessage";

import CatalogService from "@/services/catalogs/CatalogService";
import CancelButton from "@/components/buttons/CancelButton.vue";
import CreateButton from "@/components/buttons/CreateButton.vue";

export default Vue.extend({
  name: "DialogCreateItem",
  components: {CreateButton, CancelButton},
  props: {
    itemType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // Dialog
      dialog: false as boolean,

      // Item
      item: {
        name: "" as string,
        description: "" as string,
      },

      // Loading
      isLoading: false as boolean,

      // Rules
      rules: {
        required: (value: string) => !!value || 'Campo requerido',
        counter: (value: string) => (value || '').length <= 50 || 'Máximo 50 caracteres',
      },
    };
  },

  methods: {
    async createItem() {
      this.isLoading = true;
      try {
        if (this.isInvalidForm()) return;
        await CatalogService.createItem(this.item, this.itemType);
        throwSuccessMessage(`Se ha registrado ${this.item.name} correctamente`);
        this.$emit("item-created");
        this.handleDialogClose();
      } finally {
        this.isLoading = false;
      }
    },

    isInvalidForm() {
      if (!this.item.name) return true;
    },

    handleDialogClose() {
      const form = this.$refs.formCreateItem as any;
      form.resetValidation();
      this.dialog = false;
    },
  }
});
</script>